module.exports = __webpack_public_path__ + "img/Group.c71ce55f.png";